import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { MainButton } from '../components/MainButton';
import { friendsLevels } from '../lib/utils';

const PageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 960px;
  min-height: calc(100vh / var(--scale) - 140px);
  padding: 60px;
  background: #00000085;

  main {
    background: #d57bffbb !important;
    border: 1px solid #a4a5a2;
    padding: 60px 30px;
    border-radius: 65px;

    p {
      font-size: 34px;
      font-weight: 400;
      line-height: 1.1;
      color: #fff;

      span {
        color: #ffff00;
      }
    }
    header {
      padding: 0 30px;
    }
    footer {
      padding: 0 30px;
      margin-bottom: 60px;
    }
    h3 {
      font-size: 36px;
      color: #ffff00;
      text-transform: uppercase;
      letter-spacing: 1.5px;
    }
    nav {
      display: flex;
      align-items: center;
      vertical-align: middle;
      margin-bottom: 20px;
      gap: 20px;
    }
    section {
      display: flex;
      flex-direction: row;
      background: #000000a6;
      padding: 60px 0;
      margin: 40px 0;
      border-radius: 60px;
      display: flex;
      flex-direction: column;
      text-align: left;
      color: #fff;

      ul {
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-top: 20px;
        padding: 0 150px;

        li {
          font-size: 42px;
          list-style: none;
          border-bottom: 1px solid #ffffff92;
          margin-bottom: 10px;
          display: flex;
          font-weight: 400;

          &:last-of-type {
            border-bottom: 0;
          }

          span {
            flex: 1;

            &:nth-of-type(2) {
              display: block;
              text-align: right;
              align-items: end;
            }
          }
        }
      }
    }
  }
`;

const FriendsNote = () => {
  const navigate = useNavigate();

  return (
    <PageContainer>
      <main>
        <header>
          <nav>
            <h3>Treasure Box Level</h3>
            <img src="/img/IconInformation.svg" />
          </nav>
          <p>
            <span>The level of your Treasure Box</span> increases depending on the number of friends you and your
            friends have invited to the game:
          </p>
        </header>
        <section>
          <ul>
            {friendsLevels.map((level) => {
              return (
                <li>
                  <span>Level {level[0]}</span>
                  <span>{level[1].toLocaleString('us')} friends</span>
                </li>
              );
            })}
          </ul>
          <div></div>
        </section>
        <footer>
          <p>
            The higher the level of your chest, the more advantages you have in the game. <br />
            <br />
            <span>The total number of invited friends</span> of the 1st, 2nd and 3rd levels is taken into account.
          </p>
        </footer>
        <MainButton onClick={() => navigate('/')}>It's clear!</MainButton>
      </main>
    </PageContainer>
  );
};
export default FriendsNote;
